import ISpinData, {
    IOverlayData,
    ISpinificationData,
    IWinData,
} from "../../../core/src/server/data/ISpinData";
import AbstractBulkDataParser from "../../../core/src/server/parsers/AbstractBulkDataParser";
import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";
import SpinModel from "../../../core/src/model/SpinModel";
import {
    IVendorSpinData,
    IVendorLineData,
    IVendorBonusData,
} from "../../model/IVendorSpinData";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";
import VendorModel from "../../model/VendorModel";
import JackpotsModel from "../../model/JackpotsModel";
import { IBonusData } from "../../../core/src/server/data/ICustomData";
import RoundType from "../../../core/src/const/RoundType";

export default class SpinDataParser extends AbstractBulkDataParser<ISpinData> {
    protected processedData: ISpinData[];
    protected validateData(data: any): boolean {
        return (
            (data && data.stats && !data.errorCode)
        );
    }

    protected processData(data): ISpinData[] | ISpinData {
        ConsoleUtil.warn("SPIN DATA", data);
        if (data) {
            // When data is not undefined, this means this data comes from the server.
            // This is the place to reset the SpinModel.reSpinData (see also SpinModel.hasReSpins() method).
            SpinModel.reSpinData = {
                awarded: 0,
                reTriggered: 0,
                win: 0,
                remaining: 0
            };
        }

        let spinData: IVendorSpinData = data.refresh || data;
        if (SpinModel.freespinSelectScreen == null) {
            SpinModel.freespinSelectScreen = !spinData.ended || null;
        }
        
        let result: ISpinData = this.parseSlotObject(spinData, undefined, undefined, undefined, spinData.roundType);
        let results = [];
        results.push(result);

        if (spinData?.mainSpin?.symbols || spinData?.jackpotTriggeringSpin?.symbols) {
            spinData?.jackpotTriggeringSpin && !spinData?.mainSpin?.symbols ? JackpotsModel.hasDreamDrop = true : JackpotsModel.hasDreamDrop = false;
            
            this.parseFreespins(spinData, result, results);
        }

        return results;
    }

    protected parseFreespins(spinData:IVendorSpinData, result: ISpinData, results: ISpinData[]) {
        if (spinData.freespins) {
            const fsData = spinData.freespins;
            if (spinData.freespins.length) {
                result.freespinsNum = fsData.length;
                result.freespinsWon = fsData.length;
                result.totalFreeSpins = fsData.length;

                fsData.forEach((fsObj, index) => {
                    let duplicate: IVendorSpinData = Utils.deepClone(spinData);
                    duplicate.mainSpin = fsObj;
                    let fSpin = this.parseSlotObject(duplicate, true, result.winAmount, Utils.deepClone(results), RoundType.FREE_SPIN);
                    fSpin.freespinsNum = fsData.length - index - 1;

                    results.push(fSpin);
                })
            }
        } else {
            SpinModel.freespinsNum = 0;
            SpinModel.totalFreeSpins = 0;
            result.freespinsWon = (this.freespinCheck(spinData))?1:0;
        }

        // this freespin are FREE GAMES
        if(spinData.stats && spinData.stats.freespins) {
            // freespins": {
            //     "expires": 1673945789,
            //     "spinsPlayed": 5,
            //     "spins": 0,
            //     "perSpinPayouts": false,
            //     "type": "money",
            //     "win": 380,
            //     "spinsended": true,
            //     "autoplay": true,
            //     "ba": 20
        }
    }

    protected freespinCheck(data: any): boolean {
        let symbols = data.mainSpin ? data.mainSpin.symbols : data.jackpotTriggeringSpin.symbols
        let bonusCount = 0;
        const spinifyReels = GameModel.gameConfig.spinifyReels;
        const spinifySymIds = GameModel.gameConfig.spinifySymIds;
        const symMap = GameModel.gameConfig.symbolResponseMap;
        if(JackpotsModel.jackpotWin){
            return false;
        }
        for (
            let i = spinifyReels[0];
            i <= spinifyReels[spinifyReels.length - 1];
            i++) {
            if (symbols[i].find((sym) => {
                let symModifyName = sym;
                if (sym.substring(0, 2) == "WR") {
                    symModifyName = sym + "_P" + i;
                }
                return (spinifySymIds.indexOf(symMap[symModifyName].id) != -1);
            })) {
                bonusCount++;
            }
        }

        return bonusCount == spinifyReels.length;
    }

    parseSlotObject(
        spinData: IVendorSpinData,
        isFree = false,
        mainSpinWin = 0,
        previousSpins?: ISpinData[],
        roundType?: RoundType | string
    ): ISpinData {
        let winsData = spinData.mainSpin ? this.parseWins(
            spinData.mainSpin.winnings,
            spinData.bonusInfo
        ) : this.parseWins(
            spinData.jackpotTriggeringSpin.winnings,
            spinData.bonusInfo
        );
        SpinModel.symbolReplacements = spinData.mainSpin?.stackReplacements;
        let winAmount = this.getRoundWin(spinData, isFree);
        let accumulatedWin = this.getRoundWin(spinData, isFree, true);
        JackpotsModel.jackpotWin = spinData.jackpotWin
        if(JackpotsModel.jackpotWin){
            accumulatedWin > 0 ? accumulatedWin-= spinData.jackpotWin : 0;
            winAmount > 0 ? winAmount-= spinData.jackpotWin : 0;
        }
        let symbols = spinData.mainSpin ? spinData.mainSpin.symbols : spinData.jackpotTriggeringSpin.symbols
        let gridComposition = spinData.mainSpin ? spinData.mainSpin.gridComposition : spinData.jackpotTriggeringSpin.grid
        
        // if server send only grid data, we have to make an array to imitate gridComposition
        if(!gridComposition && spinData.mainSpin.grid) {
            gridComposition = [];
            if(spinData?.mainSpin &&
                spinData?.mainSpin?.grid && 
                [spinData.mainSpin.grid].length == 1) {
                for(let i = 0; i < spinData.mainSpin.stops.length; i++) {
                    gridComposition.push(spinData.mainSpin.grid);
                }
            }
        }
        
        const positions = spinData.mainSpin ? spinData.mainSpin.stops : spinData.jackpotTriggeringSpin.stops;
        const finalSyms = this.convertSymAssets(symbols || GameModel.gameConfig.defaultSymbols, spinData);
        const stopSyms = this.convertSymAssets(symbols || GameModel.gameConfig.defaultSymbols, spinData);

        const stopPositions = new Map<number, number[]>();
        const reelFinalSymbols = new Map<number, number[][]>();
        const reelStopSymbols = new Map<number, number[][]>();
        const reelSetIndex = 0; //isFree ? 1 : 0,
        stopPositions.set(reelSetIndex, positions);
        reelFinalSymbols.set(reelSetIndex, finalSyms);
        reelStopSymbols.set(reelSetIndex, stopSyms);

        let result: ISpinData = {
            winAmount,
            reelSets: this.setReelsSet(gridComposition || GameModel.gameConfig.defaultGridComposition),
            stopPositions,
            reelFinalSymbols,
            reelStopSymbols,
            winsData,
            reelSetIndex,
            isFree,
            freespinWinnings: spinData.freeGameCreditsWon || accumulatedWin,
            accumulatedWin,
            freespinsWon: 0,
            roundType
        };

        let spinification = this.parseSpinification(result);
        let overlays: IOverlayData[] = this.parseOverlays(
            result,
            spinData,
            previousSpins
        );

        const bonuses = this.parseBonuses(spinData);
        return Object.assign({}, result, {
            spinification,
            overlays,
            bonuses
        });
    }

    getRoundWin(spinData: IVendorSpinData,
        isFree: boolean,
        accumulated: boolean = false): number {
        let win: number = 0;
        if (isFree) {
            spinData.mainSpin?.winnings?.forEach((winObj) => {
                win += winObj[2];
            });
            if (accumulated) {
                win += spinData.mainSpin?.runningTotal || 0;
            }
        } else {
            if (spinData.win != undefined) {
                if (spinData.freespins && spinData.freespins.length > 0) {
                    // In case we have free spins restore (user already selected their amount),
                    // the backend will send the whole win, including free spin wins.
                    // We need to find out the real main spin win amount, because the spindata.mainSpin will equal to 0.
                    // We can get the win from the first free spin, but we need to subtract the fs winnings (if have).
                    spinData.mainSpin?.winnings?.forEach((winObj) => {
                        win += winObj[2];
                    });
                } else {
                    win = spinData.win;
                }
            } else {
                // This is a case, where the game supports free spins selection
                // and the server did not compute the total win yet,
                // because the user must first choose how many free spins s/he wants.
                // The code below computes the winnings of the main spin,
                // before the free spins selection.
                spinData.mainSpin?.winnings?.forEach((winObj) => {
                    win += winObj[2];
                });
            }
        }

        return win;
    }

    parseSpinification(result: ISpinData): ISpinificationData {
        let spinification: ISpinificationData = {
            spinificationIndex: result.reelFinalSymbols.get(result.reelSetIndex).length,
            spinificationEndIndex: result.reelFinalSymbols.get(result.reelSetIndex).length,
        };
        let spinifyCount = new Map<number, number>();

        result.reelFinalSymbols.forEach((syms, reelSetIdx) => {
            syms.forEach((reel, reelId) => {
                reel.forEach((sym, rowId) => {
                    if (GameModel.gameConfig.spinifySymIds?.indexOf(sym) != -1) {
                        if (!spinifyCount.has(sym)) {
                            spinifyCount.set(sym, 0);
                        }
                        spinifyCount.set(sym, spinifyCount.get(sym) + 1);
                        if (
                            spinifyCount.get(sym) ===
                            GameModel.gameConfig.spinifyNumSymsNeeded[sym] &&
                            GameModel.gameConfig.spinifyReels.indexOf(reelId + 1) !=
                            -1
                        ) {
                            if (
                                !spinification.spinificationIndex ||
                                spinification.spinificationIndex > reelId + 1
                            ) {
                                spinification.spinificationIndex = reelId + 1;
                                spinification.spinificationSymbolId = sym;
                                spinification.spinificationEndIndex =
                                    GameModel.gameConfig.spinifyReels[
                                    GameModel.gameConfig.spinifyReels.length - 1
                                    ];
                            }
                        }
                    }
                });
            })
        });

        return spinification;
    }

    parseLine(line: IVendorLineData): IWinData {
        // @ts-ignore
        let win: IWinData = {
            winSymbols: Array.from(
                new Array(line[3].length),
                (e, i) => {
                    return line[3][i].y;
                }
            ),
            winReels: Array.from(
                new Array(line[3].length),
                (e, i) => {
                    return line[3][i].x - 1;
                }
            ),
            winSymId: GameModel.gameConfig.symbolResponseMap[line[4]].id,
            isWay: !(
                GameModel.serverGameConfig?.paylines &&
                GameModel.serverGameConfig.paylines.length > 0
            ), //TODO
            lineId: line[1] - 1,
            normalLineWin: (line[0] == "normal") ? true : false,
            creditsWon: line[2],
        };
        let winSymId = GameModel.gameConfig.symbolResponseMap[line[4]].id
        win.coordinates = line[3].map((pos, index) => {
            return { x: pos.x, y: pos.y };
        });

        return win;
    }

    parseWins(
        winData: IVendorLineData[],
        bonusInfo: IVendorBonusData[] = []
    ): IWinData[] {
        let wins: IWinData[] = [];
        if (winData) {
            winData.forEach((line) => {
                wins.push(this.parseLine(line));
            });
        }
        // whaiting for now - troll
        // if (bonusInfo?.length) {  
        //     bonusInfo.forEach((bonus) => {
        //         if (bonus.matchPositions?.length) {
        //             wins.push(this.parseLine(bonus));
        //         }
        //     });
        // }
        return wins; // TODO
    }

    setReelsSet(currSpinReels: string[]): any[][][] {

        let result: any[][][] = [];
        let reelgrids: any[] = [];

        // TODO: Fixme - usage of Object.values() breaks older iOS support!
        Object.values(VendorModel.grids).forEach((obj) => {
            reelgrids.push(obj);
        });

        result[0] = [];
        if (currSpinReels.toString() === "jackpotSpinReels") {
            reelgrids.forEach((reelStack, j) => {
                if ("jackpotSpinReels" == reelStack.name) {
                    reelStack.reels.forEach((stack, i) => {
                        let newReel = Utils.deepClone(reelStack.reels[i]);
                        const lastElement = newReel.pop();
                        newReel.unshift(lastElement);
                        if(SpinModel.symbolReplacements) {
                            newReel = newReel.map((sym) => {
                                if(SpinModel.symbolReplacements[sym]) {
                                    sym = SpinModel.symbolReplacements[sym];
                                }
                                return sym
                            });
                        }
                        result[0][i] = newReel;
                    });
                }
            });
        } else {
            currSpinReels.forEach((reelType, i) => {
                reelgrids.forEach((reelStack, j) => {
                    if (reelType == reelStack.name) {
                        let newReel = Utils.deepClone(reelStack.reels[i]);
                        const lastElement = newReel.pop();
                        newReel.unshift(lastElement);

                        if(SpinModel.symbolReplacements) {
                            newReel = newReel.map((sym) => {
                                if(SpinModel.symbolReplacements[sym]) {
                                    sym = SpinModel.symbolReplacements[sym];
                                }
                                return sym
                            });
                        }
                        result[0][i] = newReel;
                    }
                });
            });
        }

        return result;
    }

    convertSymAssets(symData: string[][], spinData:IVendorSpinData): number[][] {
        let result: number[][] = [];
        symData.forEach((reel, i) => {
            result[i] = [];
            reel.forEach((sym, j) => {
                let symModifyName = sym;
                let obj = GameModel.gameConfig.symbolResponseMap[symModifyName].id;
                result[i][j] = obj;
            });
        });

        return result;
    }

    parseOverlays(
        result: ISpinData,
        spinData: IVendorSpinData,
        previousSpins?: ISpinData[]
    ): IOverlayData[] {
        return null;
    }

    parseBonuses(data: IVendorSpinData): IBonusData[] {
        return null;
    }
}
